import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MiniTimerContextType {
  isMiniTimerVisible: boolean;
  showMiniTimer: () => void;
  hideMiniTimer: () => void;
  toggleMiniTimer: () => void;
}

const MiniTimerContext = createContext<MiniTimerContextType | undefined>(undefined);

interface MiniTimerProviderProps {
  children: ReactNode;
}

export const MiniTimerProvider: React.FC<MiniTimerProviderProps> = ({ children }) => {
  const [isMiniTimerVisible, setIsMiniTimerVisible] = useState(false);

  const showMiniTimer = () => {
    setIsMiniTimerVisible(true);
    
    // Track mini timer open event
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'mini_timer_toggle', {
        'event_category': 'pomodoro_timer',
        'event_label': 'open'
      });
    }
  };

  const hideMiniTimer = () => {
    setIsMiniTimerVisible(false);
    
    // Track mini timer close event
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'mini_timer_toggle', {
        'event_category': 'pomodoro_timer',
        'event_label': 'close'
      });
    }
  };

  const toggleMiniTimer = () => {
    if (isMiniTimerVisible) {
      hideMiniTimer();
    } else {
      showMiniTimer();
    }
  };

  const value: MiniTimerContextType = {
    isMiniTimerVisible,
    showMiniTimer,
    hideMiniTimer,
    toggleMiniTimer
  };

  return (
    <MiniTimerContext.Provider value={value}>
      {children}
    </MiniTimerContext.Provider>
  );
};

export const useMiniTimer = (): MiniTimerContextType => {
  const context = useContext(MiniTimerContext);
  if (context === undefined) {
    throw new Error('useMiniTimer must be used within a MiniTimerProvider');
  }
  return context;
};